(function accordionScript($, Drupal) {
  Drupal.behaviors.accordion = {
    attach(context) {
      $( ".accordion", context ).accordion({
        collapsible: true,
        active: false,
        heightStyle: "content",
        activate: function(event, ui) {
          if (ui.newHeader.offset()) {
            $('body,html').animate({ scrollTop: ui.newHeader.offset().top });
          }
        }
      });
    },
  };
}(jQuery, Drupal));
